/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import { FC } from "react";
import { toAbsoluteUrl } from "../../../helpers";
import { useLang, setLanguage } from "../../../i18n/Metronici18n";
import { useIntl } from "react-intl";
import { useStyleContext } from "../../../helpers/StyleContext";

const Languages: FC = () => {
  const intl = useIntl();
  const { styleState } = useStyleContext();
  const languages = [
    {
      lang: "pt",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.PTBR",
      })}`,
      flag: toAbsoluteUrl("/media/flags/brazil.svg"),
    },
    {
      lang: "en",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.ENGLISH",
      })}`,
      flag: toAbsoluteUrl("/media/flags/united-states.svg"),
    },
    {
      lang: "es",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.SPANISH",
      })}`,
      flag: toAbsoluteUrl("/media/flags/spain.svg"),
    },
    {
      lang: "it",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.ITALIAN",
      })}`,
      flag: toAbsoluteUrl("/media/flags/italy.svg"),
    },
    {
      lang: "hr",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.CROATIAN",
      })}`,
      flag: toAbsoluteUrl("/media/flags/croatia.svg"),
    },
  ];

  const lang = useLang();
  const currentLanguage = languages.find((x) => x.lang === lang);
  return (
    <div
      className="menu-item px-5"
      data-kt-menu-trigger="hover"
      data-kt-menu-placement="left-start"
      data-kt-menu-flip="bottom"
    >
      <a
        href="#"
        className="menu-link px-5"
        style={{
          backgroundColor: styleState.toolbar_background_color,
        }}
      >
        <span
          className="menu-title position-relative"
          style={{
            color: styleState.toolbar_text_color,
          }}
        >
          {intl.formatMessage({
            id: "MENU.HEADER.USERMENU.LANGUAGES",
          })}
          <span className="fs-8 rounded bg-light px-3 py-2 position-absolute text-primary translate-middle-y top-50 end-0">
            {currentLanguage?.name}{" "}
            <img
              className="w-15px h-15px rounded-1 ms-2"
              src={currentLanguage?.flag}
              alt="metronic"
            />
          </span>
        </span>
      </a>

      <div
        className="menu-sub menu-sub-dropdown w-175px py-4"
        style={{
          backgroundColor: styleState.toolbar_background_color,
          color: styleState.toolbar_text_color,
        }}
      >
        {languages.map((l) => (
          <div
            className="menu-item px-3"
            key={l.lang}
            onClick={() => {
              setLanguage(l.lang);
            }}
          >
            <a
              href="#"
              className={clsx(
                "menu-link d-flex px-5 text-active-primary text-hover-primary",
                {
                  active: l.lang === currentLanguage?.lang,
                }
              )}
              style={{
                color: styleState.toolbar_text_color,
              }}
            >
              <span className="symbol symbol-20px me-4">
                <img className="rounded-1" src={l.flag} alt="metronic" />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export { Languages };
